export function getSanitizedHtml(html: string) {
    if (!html) {
        return "";
    }

    return html
        .replace(/\s+/g, " ") // Normalize whitespace
        .replace(/\n/g, " ") // Replace newlines with spaces
        .replace(/<p>\s*<\/p>/g, "") // Remove empty paragraphs
        .replace(/<p>(.*?)<\/p>/g, "$1") // Remove paragraph tags but keep content
        .trim(); // Remove leading/trailing whitespace
}
